import { request,request2 } from '@/utils/axiosFun.js'

// // 根据站点ID查询站点
// export const siteInfo = (query) => {
//         return request('get', '/yunDuanUrl/substation/getById/' + query)
//     }
    //修改站点信息
export const updataSiteInfo = (query) => {
    return request('post', '/yunDuanUrl/dmsm-service-cloud/substation/update', query)
}

//获取检测时间
export const getWatchTime = (query) => {
    return request('get', '/yunDuanUrl/dmsm-service-cloud/homePage/getMonitorTime/' + query)
}

//获取隔刀数量
export const getSwitchCount = (query) => {
    return request('get', '/yunDuanUrl/dmsm-service-cloud/homePage/getSwitchCount/' + query)
}

//获取缺陷次数
export const getDefectCount = (query) => {
    return request('get', '/yunDuanUrl/dmsm-service-cloud/homePage/getDefectCount/' + query)
}

//获取设备树
export const getTreeList = (query) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/homePage/getMenuList?substationId=${query.substationId}&substationName=${query.substationName}`)
}

//列表查询
export const getPageList = (query) => {
    return request('post', '/yunDuanUrl/dmsm-service-cloud/homePage/getPageList', query)
}

//获取终端安装布置图
export const getLayOut = (query) => {
    return request2('get', `/upload/${query}/终端安装布置图.png`, {}, 'blob','F','application/json',)
}

//导入 
export const excelImport = (query,file) => {
return request('POST', `/yunDuanUrl/dmsm-service-cloud/homePage/excelImport?substationName=${query.name}&substationId=${query.substation}`,file)
}

//获取功率曲线数据

export const powerCurve = (query) => {
    return request('post', `/yunDuanUrl/dmsm-service-cloud/homePage/powerCurve/${query}`)
}

//判断报告是否存在
export const findReport = (query) => {
    return request('post', `/yunDuanUrl/dmsm-service-cloud/homePage/diag/${query}`);
}
//获取报告
export const getReport = (query) => {
    return request2('get', `/upload/${query}`, {}, 'blob');
}

//修改终端ID 
export const updataDeterminID = (query) => {
    return request('post', '/yunDuanUrl/dmsm-service-cloud/termInstall/updateTermId', query)
}

//查询终端ID
export const getTermID = (query) => {
        return request('get', '/yunDuanUrl/dmsm-service-cloud/termInstall/checkTerm', query)
    }
    //获取初始化的端口号和通讯状态
export const getInitInfo = (query) => {
    return request('get', '/yunDuanUrl/dmsm-service-cloud/common/getComSignal', query);
}

//轮询
export const round = (query) => {
    return request('post', '/yunDuanUrl/dmsm-service-cloud/common/round', query);
}

//获取设备树
export const getMenuList = (query) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/homePage/getMenuList?substationId=${query.substationId}&substationName=${query.substationName}`);
}
//单位编号
export const getCompanyNumByRegion = () => {
    return request('get', '/yunDuanUrl/dmsm-service-cloud/user/getCompanyNumByRegion');
}
//单位名称
// export const getCompanyMenu = (query) => {
//     return request('get', `/yunDuanUrl/dmsm-service-cloud/homePage/getCompanyMenu`)
// }
export const getCompanyMenu = (query) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/user/getAreaAndCompanyCascadingOption`)
}

// //变电站编号
// export const getSubstationNumByCompany = () => {
//     return request('get', '/yunDuanUrl/user/getSubstationNumByCompany');
// }

//变电站名称
export const getSubstationOptionByCompany = (query) => {
    return request('post', `/yunDuanUrl/dmsm-service-cloud/user/getSubstationOptionByCompany`,query);
}

//获取用户类型
export const getDictDataByDictType = (query) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/dict/getDictDataByDictType?dictType=USER_TYPE`);
}

//读取数据
export const getReadData = () => {
    return request('post', `/yunDuanUrl/dmsm-service-cloud/homePage/readData`);
}

//删除诊断报告诊断
export const deleteDiagFile = (query) => {
    return request('post', `/yunDuanUrl/dmsm-service-cloud/homePage/delDiag`, query, '' , 'S');
}

//获取clientID
export const clientIdOption = (query) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/homePage/clientIdOption`,query,'','s');
}

//查询终端安装部署图状态列表
export const termInstallDiagramList = (query) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/homePage/termInstallDiagramList`, query, '' , 'S');
}

//查询终端安装布置图部署状态
export const termInstallDeployDiagramStatus = (params,data) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/homePage/termInstallDeployDiagramStatus?clientID=${params}`);
}

//上传终端安装布置图
export const termInstallDeployDiagram = (params,data) => {
    return request('post', `/yunDuanUrl/dmsm-service-cloud/homePage/termInstallDeployDiagram?clientID=${params}`, data, "json","F","multipart/form-data");
}

//上传终端安装图 批量
export const termInstallDiagramBatchDeploy = (params,data) => {
    return request('post', `/yunDuanUrl/dmsm-service-cloud/homePage/termInstallDiagramBatchDeploy?clientID=${params}`, data, "json","F","multipart/form-data");
}

//获取终端安装图
export const getTerminalPhoto = (query) => {
    return request2('get', `/upload/${query.substation}/${query.communicationID}_A.jpg`, {}, 'blob','F','application/json',)
}






